import {
  ActionIcon,
  AppShell,
  Box,
  Burger,
  Group,
  Portal,
  Tooltip,
} from "@mantine/core";
import { Logo } from "../../Components/Logo";
import { FC, useEffect } from "react";
import {
  IconCast,
  IconChairDirector,
  IconCommand,
  IconMaximize,
  IconMicrophone,
  IconMoneybag,
  IconShirtSport,
  IconStackFront,
  IconTournament,
  IconUser,
} from "@tabler/icons-react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { NavItem } from "../../Components/NavItem";
import { useFullscreen, useToggle } from "@mantine/hooks";
import { getPresentationParamsForOrigin } from "../../getPresentationParamsForOrigin.ts";

export const Control: FC = () => {
  const [navbarOpen, toggleNavbarOpen] = useToggle([false, true]);
  const { fullscreen, toggle: toggleFullscreen } = useFullscreen();
  const closeNavbar = () => {
    toggleNavbarOpen(false);
  };

  // Set default title for control area
  useEffect(() => {
    const competitionName = getPresentationParamsForOrigin().competitionName;
    document.title = `Control | ${competitionName}`;
  }, []);

  const headerHeight = 60;

  return (
    <>
      <ScrollRestoration />
      {!fullscreen && (
        <Portal>
          <Burger
            opened={navbarOpen}
            onClick={() => {
              toggleNavbarOpen();
            }}
            hiddenFrom="md"
            size="md"
            style={{
              position: "fixed",
              top: headerHeight / 2,
              left: "calc(100vw - 50px)",
              transform: "translateY(-50%)",
              zIndex: 1000,
            }}
          />
        </Portal>
      )}
      <AppShell
        padding="md"
        navbar={{
          width: 200,
          breakpoint: "md",
          collapsed: { mobile: !navbarOpen || fullscreen, desktop: fullscreen },
        }}
        header={{ height: fullscreen ? 0 : headerHeight }}
        styles={(theme) => ({
          main: {
            backgroundColor: theme.colors.gray[0],
            overflowX: "auto",
          },
        })}
      >
        {!fullscreen && (
          <AppShell.Header
            px="md"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              backgroundColor: "rgba(255, 255, 255, 0.85)",
              backdropFilter: "blur(12px)",
              WebkitBackdropFilter: "blur(12px)",
              borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
            }}
          >
            <Group
              h="100%"
              align="center"
              justify="space-between"
              style={{ flex: 1 }}
            >
              <Logo to="/control" />
              <Box visibleFrom="sm">
                <Tooltip label="Vollbild">
                  <ActionIcon
                    variant="subtle"
                    color="gray"
                    size="lg"
                    onClick={() => void toggleFullscreen()}
                  >
                    <IconMaximize size={20} />
                  </ActionIcon>
                </Tooltip>
              </Box>
            </Group>
          </AppShell.Header>
        )}
        {!fullscreen && (
          <AppShell.Navbar p="xs" hidden={!navbarOpen}>
            <NavItem
              to="competitions"
              onClick={closeNavbar}
              color="fwcBlue"
              icon={<IconTournament size="1rem" />}
              label="Turniere"
            />
            <NavItem
              to="teams"
              onClick={closeNavbar}
              color="yellow"
              icon={<IconShirtSport size="1rem" />}
              label="Mannschaften"
            />
            <NavItem
              to="players"
              onClick={closeNavbar}
              color="red"
              icon={<IconUser size="1rem" />}
              label="Spieler"
            />
            <NavItem
              to="timekeeper"
              onClick={closeNavbar}
              color="cyan"
              icon={<IconCommand size="1rem" />}
              label="Zeitnehmer"
            />
            <NavItem
              to="regie"
              onClick={closeNavbar}
              color="pink"
              icon={<IconChairDirector size="1rem" />}
              label="Regie"
            />
            <NavItem
              to="ledwall"
              onClick={closeNavbar}
              color="lime"
              icon={<IconCast size="1rem" />}
              label="Ledwall"
            />
            <NavItem
              to="commentator"
              onClick={closeNavbar}
              color="violet"
              icon={<IconMicrophone size="1rem" />}
              label="Kommentator"
            />
            <NavItem
              to="command"
              onClick={closeNavbar}
              color="orange"
              icon={<IconCommand size="1rem" />}
              label="Commands"
            />
            <NavItem
              to="streamelements"
              onClick={closeNavbar}
              color="black"
              icon={<IconStackFront size="1rem" />}
              label="Grafiken"
            />
            <NavItem
              to="ads"
              onClick={closeNavbar}
              color="grape"
              icon={<IconMoneybag size="1rem" />}
              label="Werbung"
            />
          </AppShell.Navbar>
        )}
        <AppShell.Main>
          <Outlet />
        </AppShell.Main>
      </AppShell>
    </>
  );
};

export default Control;
